export default __webpack_public_path__ + "static/media/asphalt.9c207e7a.png";